import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const ApplicationsView = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Applications',
    paragraph: 'Applications of Digital SERS Spectroscopy of Fluids are Everywhere. From Healthcare to Security, Detecting the nanoscopic details has never been easier.'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>


            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Advanced Energy
                  </div>
                <h3 className="mt-0 mb-12">
                  Automated Catalyst Testing Tools
                  </h3>
                <p className="m-0">
                There is growing demand for Tools in the ElectroChemistry Space, that can help speed up test and development time of new catalysts. 
                Real Time Fluid Analysis can monitor output products of the reactor to observe changes in chemical reactor performance. 
                Close the Loop between Variable Reactor Conditions and Output Products with MobileSense Fluid Spectroscopy.
                </p>
                </div>

                <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/spmobilesense-inline.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>








            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Clinical Sciences
                  </div>
                <h3 className="mt-0 mb-12">
                  Direct Sample Measurements, Repeatable Results, Customizable Reports, Automatically
                  </h3>
                <p className="m-0">
                  By Generating High Quality Data, our customers will be able to benefit from our state of the art Machine Learning algorithms.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/output-report-mobilesense.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>


            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Security
                </div>
                <h3 className="mt-0 mb-12">
                  Health Prescreening
                  </h3>
                <p className="m-0">
                   Collect Samples from your Event Attendees Before Authorizing Their Entrance. Request Health Prescreening and Ticket Validation Services For your Next Big Event.
                   Because Health is Everyone's Responsibility. </p>
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Community Health
                  </div>
                <h3 className="mt-0 mb-12">
                  Wastewater Analysis
                  </h3>
                <p className="m-0">
                Real Time Fluid Analysis can monitor for chemical residues downstream of a chemical plants, or quantify pesticides in argicultural runoff.
                Automated Water Quality Monitoring in the community results in Real Insights for Better Community Health.</p>
              </div>
            </div>


            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Resource Measuring,Reporting and Verification (MRV)
                </div>
                <h3 className="mt-0 mb-12">
                  Resource Measuring,Reporting and Verification
                  </h3>
                <p className="m-0">
                   Reversing Climate Change by sequestering Carbon Dioxide from the Ocean, or from the Atmosphere may involve complex chemical processes. 
                   MobileSense Fluid Spectroscopy can be a cost effective solution for measuring, reporting and verifying changes of chemical concentrations in solution.
                  </p>
              </div>
            </div>





          </div>
        </div>
      </div>
    </section>
  );
}

ApplicationsView.propTypes = propTypes;
ApplicationsView.defaultProps = defaultProps;

export default ApplicationsView;